// Copied rather than imported across the `advanced/` boundary: public ICD-10 data, not PHI.
export const BILLING_CODES = [
  'F10_10',
  'F10_20',
  'F10_21',
  'F10_90',
  'F11_20',
  'F12_20',
  'F20_9',
  'F25_9',
  'F31_2',
  'F31_4',
  'F31_9',
  'F31_81',
  'F32_0',
  'F32_0_PERIPARTUM',
  'F32_1',
  'F32_1_PERIPARTUM',
  'F32_2',
  'F32_2_PERIPARTUM',
  'F32_4',
  'F32_5',
  'F32_9',
  'F33_0',
  'F33_1',
  'F33_2',
  'F33_3',
  'F33_9',
  'F33_41',
  'F33_42',
  'F34_1',
  'F40_10',
  'F41_0',
  'F41_1',
  'F41_9',
  'F42_9',
  'F43_0',
  'F43_10',
  'F43_20',
  'F43_21',
  'F43_22',
  'F43_23',
  'F43_81',
  'F50_9',
  'F53_0',
  'F60_9',
  'F84_0',
  'F84_5',
  'F90_0',
  'F90_1',
  'F90_2',
] as const

export type BillingCode = (typeof BILLING_CODES)[number]

// Still valid on existing entries, but never offered when logging a new one.
const DEPRECATED_BILLING_CODES: ReadonlySet<BillingCode> = new Set([
  'F10_10',
  'F10_20',
  'F10_21',
  'F10_90',
  'F11_20',
  'F12_20',
  'F20_9',
  'F25_9',
  'F31_2',
  'F31_4',
  'F32_4',
  'F32_5',
  'F33_3',
  'F33_41',
  'F33_42',
  'F50_9',
  'F84_0',
  'F84_5',
])

export const SELECTABLE_BILLING_CODES: BillingCode[] = BILLING_CODES.filter(
  (code) => !DEPRECATED_BILLING_CODES.has(code)
)

export const BILLING_CODE_LABELS: Record<BillingCode, string> = {
  F10_10: 'Alcohol Use Disorder',
  F10_20: 'Alcohol dependence, uncomplicated',
  F10_21: 'Alcohol Dependence, in remission',
  F10_90: 'Alcohol use, unspecified, uncomplicated',
  F11_20: 'Opioid dependence, uncomplicated',
  F12_20: 'Cannabis Use Disorder',
  F20_9: 'Schizophrenia, unspecified',
  F25_9: 'Schizoaffective disorder, unspecified',
  F31_2: 'Bipolar disorder, current episode manic, severe, with psychotic features',
  F31_4: 'Bipolar disorder, current episode depressed, severe, with psychotic features',
  F31_9: 'Bipolar Disorder, unspecified',
  F31_81: 'Bipolar II Disorder',
  F32_0: 'Major Depressive Disorder, single episode, mild',
  F32_0_PERIPARTUM: 'Major Depressive Disorder, single episode, mild with peripartum onset',
  F32_1: 'Major Depressive Disorder, single episode, moderate',
  F32_1_PERIPARTUM: 'Major Depressive Disorder, single episode, moderate with peripartum onset',
  F32_2: 'Major Depressive Disorder, single episode, severe without psychotic features',
  F32_2_PERIPARTUM: 'Major Depressive Disorder, single episode, severe with peripartum onset',
  F32_4: 'Major depressive disorder, single episode, in partial remission',
  F32_5: 'Major depressive disorder, single episode, in full remission',
  F32_9: 'Major Depressive Disorder, single episode, unspecified',
  F33_0: 'Major Depressive Disorder, recurrent, mild',
  F33_1: 'Major Depressive Disorder, recurrent, moderate',
  F33_2: 'Major Depressive Disorder, recurrent, severe without psychotic symptoms',
  F33_3: 'Major depressive disorder, recurrent, severe with psychotic symptoms',
  F33_9: 'Major Depressive Disorder, recurrent, with unspecified severity',
  F33_41: 'Major Depressive Disorder, recurrent, in partial remission',
  F33_42: 'Major Depressive Disorder, Recurrent, in Full Remission',
  F34_1: 'Persistent Depressive Disorder',
  F40_10: 'Social Phobia, unspecified',
  F41_0: 'Panic Disorder',
  F41_1: 'Generalized Anxiety Disorder',
  F41_9: 'Unspecified Anxiety Disorder',
  F42_9: 'Obsessive-Compulsive Disorder, unspecified',
  F43_0: 'Acute Stress Reaction',
  F43_10: 'Post Traumatic Stress Disorder',
  F43_20: 'Adjustment Disorder, unspecified',
  F43_21: 'Adjustment Disorder with depressed mood',
  F43_22: 'Adjustment Disorder with anxiety',
  F43_23: 'Adjustment Disorder with mixed anxiety and depression',
  F43_81: 'Prolonged Grief Disorder',
  F50_9: 'eating disorder, unspecified',
  F53_0: 'Postpartum Depression',
  F60_9: 'Personality Disorder, unspecified',
  F84_0: 'Autistic disorder',
  F84_5: "Asperger's Syndrome",
  F90_0: 'Attention-Deficit/Hyperactivity Disorder, predominantly inattentive presentation',
  F90_1: 'Attention-Deficit Hyperactivity Disorder, predominantly hyperactive type',
  F90_2: 'Attention-Deficit Hyperactivity Disorder, combined type',
}
